export default "__VITE_ASSET__Ba8C50CG__"